/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Box, Grid, Typography, Tab, Tabs } from '@mui/material';

const TabPanel = ({ children, value, index, ...other }) => (
  <Typography
    aria-labelledby={`simple-tab-${index}`}
    component="div"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    role="tabpanel"
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </Typography>
);

const getWidgets = (widgets, tab) =>
  widgets.map((t, i) => (
    <TabPanel key={i} value={tab} index={i}>
      {t.element}
    </TabPanel>
  ));

const WidgetTabV2 = ({
  widgets,
  classNameAppBar,
  classNameContainer,
  currentTab,
  onChangeTab,
}) => {
  const [tab, setTab] = useState(currentTab);

  useEffect(() => {
    if (Number.isInteger(currentTab) && currentTab !== tab) setTab(currentTab);
  }, [currentTab]);

  return (
    <Grid
      className={classNameContainer}
      sx={{
        boxShadow:
          '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
        borderRadius: 1,
        bgcolor: 'background.default',
        border: (theme) => `0.5px solid ${theme.palette.neutral[800]}`,
      }}
    >
      <AppBar
        position="static"
        className={classNameAppBar}
        sx={{
          bgcolor: (theme) => theme.palette.neutral[800],
          boxShadow: 'none',
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ p: 1 }}
        >
          <Tabs value={tab} onChange={(_, newValue) => setTab(newValue)}>
            {widgets.map((t, i) => (
              <Tab
                key={i}
                label={t.label}
                disabled={t.disabled}
                sx={{ fontSize: 16, color: 'common.white' }}
              />
            ))}
          </Tabs>
        </Grid>
      </AppBar>
      {getWidgets(widgets, tab)}
    </Grid>
  );
};

WidgetTabV2.propTypes = {
  widgets: PropTypes.array.isRequired,
  currentTab: PropTypes.number,
  onChangeTab: PropTypes.func,
  children: PropTypes.node,
};

WidgetTabV2.defaultProps = {
  currentTab: 0,
  onChangeTab: () => {},
};

export default WidgetTabV2;
